import { type ReactNode } from 'react';
import { Outlet } from 'react-router';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7';

export function AppLayout(): ReactNode {
  return (
    <NuqsAdapter>
      <Outlet />
    </NuqsAdapter>
  );
}
